var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-473-6692h1690v7946H-473z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409 -6368)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    fill: "#000",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556 .5a5.47 5.47 0 0 1 5.5 5.5v7559a5.48 5.48 0 0 1-5.5 5.5H6a5.47 5.47 0 0 1-5.5-5.5V6A5.48 5.48 0 0 1 6 .5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0-22h360V87H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46BBC4",
    fillRule: "nonzero",
    d: "M37 0H11a5 5 0 0 0-5 5v38a5 5 0 0 0 5 5h21.17a2.94 2.94 0 0 0 2.13-.88l6.82-6.82a3 3 0 0 0 .88-2.13V5a5 5 0 0 0-5-5ZM8 43V5a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v33h-3.56A4.44 4.44 0 0 0 32 42.44V46H11a3 3 0 0 1-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F57361",
    fillRule: "nonzero",
    d: "M24 10.5c-5.52 0-10 4.48-10 10 0 6.13 5.05 12.47 9.29 16.71.4.39 1.03.39 1.42 0C28.95 32.97 34 26.63 34 20.5c0-5.52-4.48-10-10-10Zm0 5.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.052f9048391dcee4197d5211b270a256.svg";
export { ForwardRef as ReactComponent };